import React, {useCallback, useEffect, useState} from "react";
import {FlyoutSuperUserNavigationMenu} from "@/components/admin/FlyoutSuperUserNavigationMenu";
import {useAxiosPrivate} from "@/hooks/useAxiosPrivate";
import {SendBroadcast} from "@/components/admin/broadcast/SendBroadcast";
import {TemplateManager} from "@/components/admin/broadcast/TemplateManager";
import {getWhatsAppTemplatesApi} from "@/service/admin/broadcastApi";
import {toast} from "react-toastify";

export const Broadcast = ({selectedMenuOption, setSelectedMenuOption}) => {
	const axiosPrivate = useAxiosPrivate();
	const [activeTab, setActiveTab] = useState("send");
	const [templates, setTemplates] = useState([]);
	const tabs = [
		{id: "send", label: "Send Broadcast"},
		{id: "templates", label: "Template Manager"},
	];

	const loadTemplates = useCallback(async () => {
		try {
			const response = await getWhatsAppTemplatesApi(axiosPrivate);
			setTemplates(response.data ?? []);
		} catch (error) {
			toast.error(error?.response?.data?.message ?? "Failed to load WhatsApp templates.");
		}
	}, [axiosPrivate]);

	useEffect(() => {
		loadTemplates();
	}, [loadTemplates]);

	return (
		<div
			className="flex h-full flex-col gap-3 overflow-hidden
                portrait:p-[0.75rem] portrait:jk:p-[1.25rem]
                landscape:px-[1rem] landscape:py-[0.75rem]
                landscape:jk:px-[1rem] landscape:jk:py-[0.75rem]"
		>
			<div className="flex flex-wrap items-center justify-between gap-3">
				<div className="flex items-center gap-2">
					<FlyoutSuperUserNavigationMenu
						selectedMenuOption={selectedMenuOption}
						setSelectedMenuOption={setSelectedMenuOption}
					/>
					<div>
						<h1
							className="font-custom-bold leading-tight
                            portrait:text-[1.5rem] portrait:md:text-[1.375rem]
                            portrait:jk:text-[1.5rem] portrait:lg:text-[2rem]
                            landscape:text-[0.9rem] landscape:md:text-[1rem]
                            landscape:jk:text-[1.1rem] landscape:lg:text-[1.5rem]"
						>
							Broadcast
						</h1>
						<p className="font-custom-regular text-sm text-gray-500">Send WhatsApp and email announcements to selected members.</p>
					</div>
				</div>

				<div className="flex rounded-xl bg-gray-100 p-1">
					{tabs.map((tab) => (
						<button
							key={tab.id}
							type="button"
							onClick={() => setActiveTab(tab.id)}
							className={`rounded-lg px-3 py-2 text-sm font-custom-semi-bold transition ${activeTab === tab.id ? "bg-white text-[#A20000] shadow-sm" : "text-gray-600 hover:text-gray-950"}`}
						>
							{tab.label}
						</button>
					))}
				</div>
			</div>

			<div className="min-h-0 flex-1 overflow-hidden">
				{activeTab === "send" ? (
					<SendBroadcast axiosPrivate={axiosPrivate} templates={templates}/>
				) : (
					<TemplateManager
						axiosPrivate={axiosPrivate}
						templates={templates}
						setTemplates={setTemplates}
						onTemplatesChanged={loadTemplates}
					/>
				)}
			</div>
		</div>
	);
};
